import { render, staticRenderFns } from "./UOttawaLabExamPt2_2024.vue?vue&type=template&id=3cefe144&scoped=true&"
import script from "./UOttawaLabExamPt2_2024.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExamPt2_2024.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExamPt2_2024.vue?vue&type=style&index=0&id=3cefe144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cefe144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
